import { ModalSize } from '../../services/modal/mvd-modal.enum';
import { MvdModalService } from '../../services/modal/mvd-modal.service';
import { SharedConfirmData } from './confirmation-data.model';

export class SharedWarningData extends SharedConfirmData {
    constructor(caller: MvdModalService = undefined) {
        super(caller);
    }

    // open modal to size (optional)
    open(size?: ModalSize) {
        return this.caller.warningModal(this, size);
    }
}
